export default "__VITE_ASSET__85xt6jpi__"